module.exports = "https://jsak.mmtcdn.com/tripmoney/static/media/manhattan.37951079.jpeg";